import {
  IonButton,
  IonButtons,
  IonChip,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonModal,
  IonSearchbar,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { closeOutline } from "ionicons/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLocation } from "../../../store/MassNotification";
import { selectLocationAreaNegocio } from "../../../store/massiveDocumentCreate/selectors/selectLocationAreaNegocio";
import { selectCreateFilters } from "../../../store/MassNotification/selectors/selectCreateFilters";

export const UsersSelectorLocationFilter: React.FC = () => {
  const dispatch = useDispatch();
  const createFilters = useSelector(selectCreateFilters);
  const locationAreaNegocioList = useSelector(selectLocationAreaNegocio);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [listSearchtext, setListSearchtext] = useState("");

  return (
    <section>
      <IonChip
        onClick={() => setShowFilterModal(true)}
        outline
        color={createFilters.location ? "primary" : "medium"}
      >
        <IonLabel class="ion-text-nowrap">
          {createFilters.location?.id ? (
            <IonText color="primary" style={{ fontWeight: 600 }}>
              <span>Área de negocio: </span>
              {createFilters.location?.name}
            </IonText>
          ) : (
            <span>Área de negocio: Todos</span>
          )}
        </IonLabel>
      </IonChip>

      <IonModal isOpen={showFilterModal} onDidDismiss={() => setShowFilterModal(false)}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Filtrar por área de negocio</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setShowFilterModal(false)}>
                <IonIcon icon={closeOutline} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonSearchbar
            value={listSearchtext}
            onIonChange={({ detail: { value = "" } }) => {
              setListSearchtext(value);
            }}
            debounce={900}
            placeholder="Buscar"
          />
          <IonList>
            <IonListHeader>Áreas de negocio</IonListHeader>
            {locationAreaNegocioList
              .filter(({ name }) => name?.toLowerCase().includes(listSearchtext.toLowerCase()))
              .map((location, index: number) => (
                <IonItem
                  key={index}
                  onClick={() => {
                    dispatch(setLocation(location));
                    setShowFilterModal(false);
                  }}
                  button
                  detail
                >
                  <IonLabel>{location.name}</IonLabel>
                </IonItem>
              ))}
          </IonList>
        </IonContent>
      </IonModal>
    </section>
  );
};
